

























































import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { ReabrirVendaUseCase} from '@/usecases'
import { Vue, Component, Watch, Ref } from 'vue-property-decorator'

@Component
export default class DialogoDeReabrirVenda extends Vue {
	@Ref() form!: HTMLFormElement
	mostra = false
	identificador = ''
	reabrirVendaUseCase = new ReabrirVendaUseCase()
	reabrindo = false

	mostrar(){
		this.mostra = true
	}

	fechar(){
		this.mostra = false
	}

	async enviaIdentificador(){
		try {
			if (!this.form.validate()) return
			this.reabrindo = true
			await this.reabrirVendaUseCase.reabrir(this.identificador)
			this.fechar()
		} catch(e) {
			AlertModule.setError(e)
		} finally {
			this.reabrindo = false
		}
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean, mostraAnterior: boolean) {
		if (mostra && !mostraAnterior) {
			this.identificador = ''
			window.requestAnimationFrame(() => {
				this.form.resetValidation()
			})
		}
	}
}

